import { trackEvent } from './components/GoogleAnalytics/trackEvent';
import { tagEvent } from './Hotjar/tagEvent';
export function track(category, action, label, value = null, {
  skipGoogle,
  skipHotjar
} = {
  skipGoogle: false,
  skipHotjar: false
}) {
  if (skipGoogle !== true) {
    trackEvent(category, action, label, value);
  }

  if (skipHotjar !== true) {
    tagEvent(`${category} ${action} ${label}`);
  }
}